// Agrupa as falhas da página carregada por motivo, para o relatório deixar de
// ser lido caso a caso e passar a ser lido causa a causa: "12 fora da janela de
// 24h" diz o que fazer; doze linhas vermelhas iguais, não.
//
// Só enxerga o que a lista já tem em mãos (os 30 itens da página). O rótulo na
// tela precisa dizer isso — um total que parece do período inteiro engana.

import { translateMetaError } from './metaErrors'
import { isMetaOfficialProvider } from './metaTemplates'
import { getMessageStatus } from './messageStatus'

const SEM_MOTIVO = 'Motivo não informado'

// Chave de agrupamento para erro de conexão direta (Baileys), onde o backend já
// manda o texto em pt-br: caixa e espaço extra não podem criar grupos separados.
function normalizarChave(texto) {
  return String(texto || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
}

function motivoDaFalha(message, provider) {
  const erro = message.erro

  if (isMetaOfficialProvider(provider)) {
    const amigavel = translateMetaError(erro)
    if (amigavel && amigavel.titulo) {
      return { chave: normalizarChave(amigavel.titulo), titulo: amigavel.titulo }
    }
    return { chave: normalizarChave(SEM_MOTIVO), titulo: SEM_MOTIVO }
  }

  const texto = erro && erro.text ? String(erro.text).trim() : ''
  if (!texto) return { chave: normalizarChave(SEM_MOTIVO), titulo: SEM_MOTIVO }

  return { chave: normalizarChave(texto), titulo: texto }
}

export function buildFailureDigest(messages, { provider } = {}) {
  const lista = Array.isArray(messages) ? messages : []
  const grupos = new Map()

  lista.forEach((message) => {
    // A mesma regra da linha decide o que é falha — inclusive a exclusão da
    // mensagem que chegou ao destinatário carregando erro de tentativa anterior.
    if (!getMessageStatus(message).ehFalha) return

    const { chave, titulo } = motivoDaFalha(message, provider)
    const grupo = grupos.get(chave)

    if (grupo) {
      grupo.quantidade += 1
      grupo.ids.push(message._id)
      return
    }

    // O título guardado é a primeira grafia encontrada; as variações de caixa e
    // espaço já foram absorvidas pela chave.
    grupos.set(chave, { chave, titulo, quantidade: 1, ids: [message._id] })
  })

  return Array.from(grupos.values()).sort((a, b) => {
    if (b.quantidade !== a.quantidade) return b.quantidade - a.quantidade
    return a.titulo.localeCompare(b.titulo, 'pt-BR')
  })
}

const failureDigestLib = { buildFailureDigest }

export default failureDigestLib
